export default "__VITE_ASSET__CoucYAvw__"